import { useMemo } from 'react'
import { IMoreMenuItem } from '@sales-center/components'
import { useDialogState } from '@user/utils/useDialogState'
import { NotesDrawerState } from './typings'

type Params = {
  canUpdate: boolean
  detailPage: boolean
}

export function useNotesDrawer(params: Params): NotesDrawerState {
  const { detailPage, canUpdate } = params

  const [notesDrawerOpen, onOpenNotesDrawer, onCloseNotesDrawer] =
    useDialogState()
  const [viewNotesModalOpen, showViewNoteModal, hideViewNoteModal] =
    useDialogState()

  const notesMenuItem = useMemo<IMoreMenuItem>(
    () => ({
      label: 'Add/View Note',
      hidden: detailPage,
      onClick: showViewNoteModal,
      disabled: false,
      dataTestId: `add-view-notes-btn`,
      tooltipText: undefined,
    }),
    [detailPage, showViewNoteModal],
  )

  return {
    notesDrawerOpen,
    onOpenNotesDrawer,
    onCloseNotesDrawer,
    notesMenuItem,
    viewNotesModalOpen,
    hideViewNoteModal,
    canUpdate,
    showViewNoteModal,
  }
}
